// extracted by mini-css-extract-plugin
export default {"flex":"flex_flex__AbGgR","inline":"flex_inline__JZru0"};